module.exports = __webpack_public_path__ + "assets/no-study-set.9b39da2a.svg";